import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const BalanceTransferService = {
  getAllBalanceTransfers,
  getAllBalanceTransfersWithParams,
  getBalanceTransferById,
  postBalanceTransfer,
  updateBalanceTransfer,
  deleteBalanceTransfer,
};

function getAllBalanceTransfers() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/balance-transfer`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllBalanceTransfersWithParams(queryParams) {
  const { siteId, balanceCatalogueId } = queryParams;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/balance-transfer`, {
      params: {
        siteId,
        balanceCatalogueId,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getBalanceTransferById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/balance-transfer/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function postBalanceTransfer(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/balance-transfer`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateBalanceTransfer(body, id) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/balance-transfer?id=${id}`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteBalanceTransfer(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`${BASE_URL_DEV}/balance-transfer?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
